export const DoppeActionTypeEventViewerLang = {
    defaultTexts: {
        eventTitle: 'Event title',
        description: 'Describe the event you want to promote',
        eventButtonText: 'Join Now',
    }
}